(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yl-champagne-cursor"] && !Shopify.designMode) return;
  try {
    (() => {
    const ring = document.querySelector('.yl-champagne-cursor');
    if (!ring) return;

    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!finePointer.matches) return;

    const interactiveSelector = "a[href], button:not(:disabled), summary, [role='button']:not([aria-disabled='true']), input[type='submit']:not(:disabled), input[type='button']:not(:disabled), .button";
    let activeTarget = null;
    let leaveTimer = null;
    let shatterTimer = null;

    const showRing = () => {
      window.clearTimeout(leaveTimer);
      ring.classList.remove('is-leaving', 'is-shattering', 'is-interactive');
      void ring.offsetWidth;
      ring.classList.add('is-interactive');
    };

    const hideRing = () => {
      if (ring.classList.contains('is-shattering')) return;

      window.clearTimeout(leaveTimer);
      ring.classList.remove('is-interactive', 'is-leaving');
      void ring.offsetWidth;
      ring.classList.add('is-leaving');

      leaveTimer = window.setTimeout(() => {
        ring.classList.remove('is-leaving');
      }, 300);
    };

    const setPosition = (event) => {
      ring.style.left = event.clientX + 'px';
      ring.style.top = event.clientY + 'px';

      const target = event.target instanceof Element ? event.target.closest(interactiveSelector) : null;

      if (target === activeTarget) return;

      activeTarget = target;

      if (activeTarget) {
        showRing();
      } else {
        hideRing();
      }
    };

    const shatter = () => {
      if (!activeTarget) return;

      window.clearTimeout(leaveTimer);
      window.clearTimeout(shatterTimer);
      ring.classList.remove('is-interactive', 'is-leaving', 'is-shattering');
      void ring.offsetWidth;
      ring.classList.add('is-shattering');

      shatterTimer = window.setTimeout(() => {
        ring.classList.remove('is-shattering');

        if (activeTarget) {
          showRing();
        }
      }, 560);
    };

    window.addEventListener('pointermove', setPosition, { passive: true });
    window.addEventListener('pointerdown', shatter, { passive: true });

    window.addEventListener('blur', () => {
      activeTarget = null;
      window.clearTimeout(leaveTimer);
      window.clearTimeout(shatterTimer);
      ring.classList.remove('is-interactive', 'is-leaving', 'is-shattering');
    });

    document.addEventListener('mouseleave', () => {
      activeTarget = null;
      hideRing();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
